import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { CourseLevel } from '../../../../interfaces/couse-level';

export const CourseLevelLabels: Record<CourseLevel, string> = {
  beginner: 'Iniciante',
  intermediate: 'Intermediário',
  advanced: 'Avançado',
};

@Component({
  selector: 'app-complexity-level',
  imports: [],
  templateUrl: './complexity-level.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplexityLevelComponent {
  level = input.required<CourseLevel>();

  levelLabel = computed(() => CourseLevelLabels[this.level()]);
}
